import React from "react";
import { css, Theme } from "@mui/material";
import { styled } from "@mui/material/styles";
import { UserAvatarAltType, UserAvatarType } from "components/UserAvatar/UserAvatar.types";
import FontIcon, { ODL_ICONS } from "@odl/core/components/DataDisplay/FontIcon";

type Props = {
  rectSize: number;
  fontSize: number;
  disabled?: boolean;
  type?: UserAvatarType;
  avatarType?: UserAvatarAltType;
};

const UserAvatarAlt: React.FC<Props> = ({
  rectSize,
  fontSize,
  disabled = false,
  type = UserAvatarType.Solid,
  avatarType = UserAvatarAltType.Group,
}) => {
  const icon = avatarType === UserAvatarAltType.Group ? ODL_ICONS.USER_EVENTS : ODL_ICONS.TOOLS_PORTFOLIO;

  return (
    <StyledUserGroupAvatar $rectSize={rectSize} $fontSize={fontSize} $type={type} $disabled={disabled}>
      <StyledFontIcon name={icon} fontSize={fontSize} />
    </StyledUserGroupAvatar>
  );
};

const StyledFontIcon = styled(FontIcon)(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
  `
);

const StyledUserGroupAvatar = styled("div", {
  shouldForwardProp: (prop) => !["$rectSize", "$fontSize", "$type", "$disabled"].includes(prop.toString()),
})<{
  theme: Theme;
  $rectSize: number;
  $fontSize: number;
  $type?: UserAvatarType;
}>(
  ({ theme, $rectSize, $fontSize, $type, $disabled }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${$rectSize}px;
    height: ${$rectSize}px;
    border-radius: ${$rectSize}px;
    font-size: ${$fontSize}px;
    display: flex;
    background-color: ${theme.palette.brand?.teams};
    ${
      $type === UserAvatarType.Solid &&
      !$disabled &&
      `
        border: none;
        background-color: ${theme.palette.brand?.teams};
        color: ${theme.palette.paper?.main};
      `
    }
    ${
      $type === UserAvatarType.Outlined &&
      !$disabled &&
      `
        border: 2px solid ${theme.palette.brand?.teams};
        background-color: transparent;
        color: ${theme.palette.brand?.teams};
      `
    }

    ${
      $type === UserAvatarType.Solid &&
      $disabled &&
      `
        border: none;
        background-color: ${theme.palette.grey[600]};
        color: ${theme.palette.paper?.main};
      `
    }
    ${
      $type === UserAvatarType.Outlined &&
      $disabled &&
      `
        border: 2px solid ${theme.palette.grey[600]};
        background-color: transparent;
        color: ${theme.palette.grey[600]};
      `
    }
  `
);
export default UserAvatarAlt;
